import Swiper from "swiper/bundle";

const [ w, d, mq ] = [window, document, window.matchMedia( "(max-width: 900px)" ) ];
const domReady = TPL => {
  new BLOCKS;
};

class BLOCKS {
  constructor() {
    this.mainvisual();
  }

  mainvisual () {
    let mainVisual = document.querySelector('.mainvisual');
    w.addEventListener('load', function() {
      mainVisual.classList.add('loaded');
    });

    //メインスライダー
    const mvSlide = new Swiper('.mainvisual__slide[data-plugin="mainSlider"]',{
      loop: true,
      effect: 'fade',
      speed: 1200,
      allowTouchMove: false,
      fadeEffect: {
        crossFade: true, // クロスフェードを有効にする（フェードモードの場合 true 推奨）
      },
      autoplay:{
        delay: 4000,
        disableOnInteraction: false,
        waitForTransition: false
      },
    });
  }
}

const jqInit = () => false;

export default function HOME () {
  // テンプレートが用意したDOMContentLoaded（テンプレートインスタンスが引数に入る）
  d.addEventListener('app.beforeDomready', e => domReady(e.detail) );
  
  $(() => jqInit());
}